/* tslint:disable */
/* eslint-disable */
/**
 * Rick and Morty API
 * API for fetching character information from Rick and Morty series
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FetchAllCharacters200ResponseInfo
 */
export interface FetchAllCharacters200ResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof FetchAllCharacters200ResponseInfo
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof FetchAllCharacters200ResponseInfo
     */
    pages?: number;
    /**
     * 
     * @type {string}
     * @memberof FetchAllCharacters200ResponseInfo
     */
    next?: string;
    /**
     * 
     * @type {string}
     * @memberof FetchAllCharacters200ResponseInfo
     */
    prev?: string;
}

/**
 * Check if a given object implements the FetchAllCharacters200ResponseInfo interface.
 */
export function instanceOfFetchAllCharacters200ResponseInfo(value: object): boolean {
    return true;
}

export function FetchAllCharacters200ResponseInfoFromJSON(json: any): FetchAllCharacters200ResponseInfo {
    return FetchAllCharacters200ResponseInfoFromJSONTyped(json, false);
}

export function FetchAllCharacters200ResponseInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FetchAllCharacters200ResponseInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'next': json['next'] == null ? undefined : json['next'],
        'prev': json['prev'] == null ? undefined : json['prev'],
    };
}

export function FetchAllCharacters200ResponseInfoToJSON(value?: FetchAllCharacters200ResponseInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'pages': value['pages'],
        'next': value['next'],
        'prev': value['prev'],
    };
}

